// extracted by mini-css-extract-plugin
export default {"noteContainer":"FormNotes_noteContainer__dejCp","notesDiv":"FormNotes_notesDiv__KTdP6"};